// Adapted from Hosanna 1412aa0; see docs/search.md.
export function normalizeSearchText(value) {
    return value
        .replace(/[łŁ]/g, (char) => (char === 'Ł' ? 'L' : 'l'))
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^\p{L}\p{N}\s]/gu, ' ')
        .replace(/\s+/g, ' ')
        .trim();
}
/** Normalize text with the same rules as search while retaining UTF-16 source offsets. */
function normalizeSearchTextWithOffsets(value) {
    let text = '';
    const sourceRanges = [];
    let sourceOffset = 0;
    for (const originalCharacter of value) {
        const sourceStart = sourceOffset;
        sourceOffset += originalCharacter.length;
        const folded = originalCharacter
            .replace(/[łŁ]/g, (character) => (character === 'Ł' ? 'L' : 'l'))
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase();
        if (!folded && /\p{M}/u.test(originalCharacter) && sourceRanges.length) {
            sourceRanges[sourceRanges.length - 1].end = sourceOffset;
        }
        for (const character of folded) {
            const isSearchCharacter = /[\p{L}\p{N}]/u.test(character);
            if (!isSearchCharacter) {
                if (text.length > 0 && !text.endsWith(' ')) {
                    text += ' ';
                    sourceRanges.push({ start: sourceStart, end: sourceOffset });
                }
                continue;
            }
            text += character;
            for (let index = 0; index < character.length; index += 1) {
                sourceRanges.push({ start: sourceStart, end: sourceOffset });
            }
        }
    }
    if (text.endsWith(' ')) {
        text = text.slice(0, -1);
        sourceRanges.pop();
    }
    return { text, sourceRanges };
}
export function findSearchTextRanges(text, queryTerms) {
    const normalized = normalizeSearchTextWithOffsets(text);
    const ranges = [];
    for (const term of [...new Set(queryTerms.filter(Boolean))]) {
        let offset = 0;
        while (offset < normalized.text.length) {
            const index = normalized.text.indexOf(term, offset);
            if (index < 0)
                break;
            const first = normalized.sourceRanges[index];
            const last = normalized.sourceRanges[index + term.length - 1];
            if (first && last)
                ranges.push({ start: first.start, end: last.end });
            offset = index + term.length;
        }
    }
    ranges.sort((left, right) => left.start - right.start || left.end - right.end);
    const merged = [];
    for (const range of ranges) {
        const previous = merged[merged.length - 1];
        if (previous && range.start < previous.end)
            previous.end = Math.max(previous.end, range.end);
        else
            merged.push({ ...range });
    }
    return merged;
}
function findSearchSpanEnd(text, cursor, maxLength) {
    const limit = Math.min(text.length, cursor + maxLength);
    if (limit >= text.length)
        return limit;
    const minimumBoundary = cursor + Math.floor(maxLength / 2);
    const boundary = Math.max(text.lastIndexOf('\n', limit), text.lastIndexOf(' ', limit));
    return boundary >= minimumBoundary ? boundary : limit;
}
function trimSearchSpan(text, start, end) {
    let trimmedStart = start;
    let trimmedEnd = end;
    while (trimmedStart < trimmedEnd && /\s/u.test(text[trimmedStart] ?? ''))
        trimmedStart += 1;
    while (trimmedEnd > trimmedStart && /\s/u.test(text[trimmedEnd - 1] ?? ''))
        trimmedEnd -= 1;
    return trimmedEnd > trimmedStart
        ? { text: text.slice(trimmedStart, trimmedEnd), start: trimmedStart, end: trimmedEnd }
        : null;
}
export function splitSearchTextIntoSpans(text, maxLength = 480) {
    const spans = [];
    let cursor = 0;
    while (cursor < text.length) {
        const rawEnd = findSearchSpanEnd(text, cursor, maxLength);
        const span = trimSearchSpan(text, cursor, rawEnd);
        if (span)
            spans.push(span);
        cursor = Math.max(rawEnd, cursor + 1);
    }
    return spans;
}
